import { usePageTitle } from '@trukt/react-hooks/usePageTitle';
import { useAppVariant } from '../../hooks/useAppVariant';
import { PageTitleProps } from './PageTitle.types';

export const PageTitle = ({ title, children }: PageTitleProps) => {
  const { isClientPortal } = useAppVariant();
  usePageTitle({ title, isClientPortal });

  return children;
};
